export default __webpack_public_path__ + "77e9d3d576900307cfb1c1bbf11fec1a.jpg";